import { Autocomplete } from './autocomplete';

export default Autocomplete;
